import { createApp } from 'vue';
import dayjs from 'dayjs';
import Header from '@/components/TheHeader.vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueMixpanel from 'vue-mixpanel';
import VueCookies from 'vue-cookies'
import VideoBackground from "@/components/VideoBackground/VideoBackground.vue";
// import VueAB from 'vue-a2b';
import '@/assets/scss/styles.scss';
import '@/assets/fonts/fonts.css';
import '@unocss/reset/tailwind.css'
import 'uno.css'
import { vfmPlugin } from 'vue-final-modal'
import * as Sentry from "@sentry/vue";
// import { CaptureConsole } from "@sentry/integrations";
import versionPlugin from "@/plugins/version-plugin";
import applePayPlugin from '@/plugins/apple-pay-plugin'
import openReplay from '@/plugins/open-replay'
import i18n from "@/i18n";

const app = createApp(App);

Sentry.init({
  app,
  dsn: process.env.VUE_APP_SENTRY_DNS,
  environment: process.env.VUE_APP_SENTRY_ENV,
  integrations: [
    new Sentry.BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", "quiz.kegel.men", "quiz.kegel-plan.com", /^\//],
      routingInstrumentation: Sentry.vueRouterInstrumentation(router)
    }),
    // new Sentry.Replay({
    //     networkDetailAllowUrls: ['https://int2.kegel.men/api/web-payment/init/card-payment/', 'https://int2.kegel.men/api/web-payment/init/pay-pal-payment/'],
    //     networkRequestHeaders: ['X-Custom-Header'],
    //     networkResponseHeaders: ['X-Custom-Header'],
    //   }),
    // new CaptureConsole({
    //     levels: ['error', 'debug', 'assert']
    // }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

    app.use({install(app) {
    dayjs.locale('en')
    app.config.globalProperties.$dayjs = dayjs;
    }})
    // .use(VueAB)
    app.use(VueCookies);
    app.use(versionPlugin);
    app.use(applePayPlugin);
    app.use(openReplay);
    app.use(store(app.config.globalProperties.$tracker));
    app.use(router);
    app.use(i18n);
    app.use(vfmPlugin);
    app.component('header-layout', Header);
    app.use(VueMixpanel, {
        token: 'd8038d374838b13ef8ac565b08be6135',
        config: {
            debug: true,
            ignore_dnt: true,
        }
    });
    app.component('video-background', VideoBackground)
    app.mount('#app');
